import React, { memo } from "react"

import { ButtonSmall } from "../Button"
import { ReactComponent as CloseIcon } from "../../assets/images/close_icon.svg"
import styles from "./Modal.module.scss"

type CustomPopupProps = {
    showCloseIcon: boolean
    headerText?: string
    backgroundColor?: string
    cancelButtonText: string
    submitButtonText: string
    hideCancelButton: boolean
    hideSubmitButton: boolean
    description: string
    modalContent: JSX.Element
    isShown: boolean
    width?: any
    padding?: any
    handleClose: (value: any) => void
    handleSubmit?: (value: any) => void
    height?: string
    zIndex?: any
    maxHeight?: string
    maxWidth?: string
    minWidth?: string
    minHeight?: string
    version?: any
    overflow?: string
    footerHeight?: any
    headerHeight?: any
    notCloseable?: boolean
    sub_heading?: any
    headerStyle?: React.CSSProperties
    backdropZIndex?: any
    backdropBoxShadow?: any
    backdropColor?: any
    transform?: string
    innerContainerClassName?: string
}

const CustomPopup = (props: CustomPopupProps) => {
    const {
        isShown = true,
        showCloseIcon,
        headerText,
        hideCancelButton,
        hideSubmitButton,
        cancelButtonText,
        submitButtonText,
        description,
        modalContent,
        version,
        handleClose,
        handleSubmit,
        notCloseable,
        footerHeight,
        headerHeight,
        backdropZIndex,
        backdropColor,
        backdropBoxShadow,
    } = props
    return isShown ? (
        <>
            <div
                className={`${styles.backdrop}`}
                style={{
                    zIndex: backdropZIndex ? backdropZIndex : 500,
                    backgroundColor: backdropColor ? backdropColor : "",
                    boxShadow: backdropBoxShadow ? backdropBoxShadow : "",
                }}
                onClick={(event: React.MouseEvent<HTMLElement>) =>
                    showCloseIcon ? "" : notCloseable ? "" : handleClose(event)
                }></div>
            <div
                id="modal_container"
                className={`${styles.popup_container}`}
                style={{
                    overflow: props?.overflow,
                    width: props.width ? `min(${props.width}, 94vw)` : undefined,
                    padding: `${props.padding}`,
                    maxHeight: props.maxHeight ? `min(${props.maxHeight}, 94vh)` : "94vh",
                    minHeight: `${props.minHeight}`,
                    maxWidth: props.maxWidth ? `min(${props.maxWidth}, 94vw)` : "94vw",
                    minWidth: props.minWidth ? `min(${props.minWidth}, 94vw)` : undefined,
                    height: props.height ? `min(${props.height}, 94vh)` : undefined,
                    transform: `${props.transform}`,
                    backgroundColor: `${props.backgroundColor}`,
                    zIndex: props?.zIndex,
                    boxShadow: backdropZIndex ? "0px 0px 8px 0px #D2D2D1" : backdropBoxShadow ? backdropBoxShadow : "",
                }}>
                {(version === 2 || version === 3) && (
                    <div
                        style={{ height: headerHeight ? headerHeight : "" }}
                        className={styles.header_background}></div>
                )}
                {(version === 2 || version === 3 || version === 3.5) && (
                    <div
                        style={{ height: footerHeight ? footerHeight : "" }}
                        className={styles.footer_background}></div>
                )}
                <div className={`${styles.popup_container__inr} ${props?.innerContainerClassName || ""}`}>
                    {(Boolean(headerText) || showCloseIcon) && (
                        <div
                            className={`${styles.popup_container__inr__header} ${version === 3 ? styles.v3margin : ""}`}>
                            <span className={`${styles.header_text}`} style={props?.headerStyle}>
                                {headerText}
                            </span>
                            {showCloseIcon &&
                                (version === 2 || version === 3 ? (
                                    <span
                                        className={`${styles.close_icon}`}
                                        onClick={props.handleClose}
                                        style={{
                                            position: "relative",
                                            top: version === 3 ? "-3px" : "-17px",
                                            right: version === 3 ? "5px" : " -10px",
                                        }}>
                                        <CloseIcon height={"12px"} width={"12px"} />
                                    </span>
                                ) : (
                                    <span className={`${styles.close_icon}`} onClick={props.handleClose}>
                                        <CloseIcon />
                                    </span>
                                ))}
                        </div>
                    )}
                    {props?.sub_heading && <div className={styles.sub_heading}>{props.sub_heading}</div>}
                    <div
                        className={`${styles.popup_description}`}
                        style={{
                            overflowY: version === 3 || version === 3.5 ? "scroll" : "visible",
                            height:
                                props?.height && version === 3
                                    ? `${
                                          parseInt(props.height?.slice(0, -2)) -
                                          (parseInt(props.footerHeight?.slice(0, -2)) +
                                              parseInt(props.headerHeight?.slice(0, -2)))
                                      }px`
                                    : "",
                        }}>
                        {modalContent ? modalContent : null}
                        {description ? <p>{description}</p> : null}
                    </div>
                    <div className={`${styles.button_container} ${version === 3 ? styles.v3Button : ""}`}>
                        <ButtonSmall
                            style={{
                                display: hideCancelButton ? "none" : "block",
                                backgroundColor: version === 3.5 ? "transparent" : "",
                            }}
                            className={`${styles.submitButton_cancel}`}
                            onClick={handleClose}>
                            {cancelButtonText}
                        </ButtonSmall>
                        {version === 3 ? (
                            <ButtonSmall
                                style={
                                    hideSubmitButton ? { display: "none" } : { display: "block", position: "relative" }
                                }>
                                <label htmlFor="file-uploader">{submitButtonText}</label>
                                <input
                                    id="file-uploader"
                                    type="file"
                                    className={styles.submitButton_submit_v3}
                                    onChange={e => handleSubmit && handleSubmit(e)}
                                    multiple
                                />
                            </ButtonSmall>
                        ) : (
                            <ButtonSmall
                                style={hideSubmitButton ? { display: "none" } : { display: "block" }}
                                className={`${styles.submitButton_submit}`}
                                onClick={handleSubmit}>
                                {submitButtonText}
                            </ButtonSmall>
                        )}
                    </div>
                </div>
            </div>
        </>
    ) : null
}
const CustomModal = memo(CustomPopup)
export default CustomModal
